import {
  getFirestore,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const getUsers = async ({ state, commit }) => {
  const db = getFirestore();
  const auth = getAuth();
  commit('SET_STATE', { key: 'isLoading', value: true });

  const { currentUser } = auth;
  const { claims } = await currentUser.getIdTokenResult();
  const userDocRef = doc(db, 'users', claims.user_id);
  const snapshotUser = await getDoc(userDocRef);
  const userData = snapshotUser.data();

  let usersQuery;
  if (claims?.superAdmin) {
    usersQuery = query(
      collection(db, 'users'),
      where('role', 'in', ['superAdmin', 'eyeStaff', 'orgAdmin', 'orgUser']),
    );
  } else if (claims?.eyeStaff) {
    usersQuery = query(
      collection(db, 'users'),
      where('role', 'in', ['orgAdmin', 'orgUser', 'eyeStaff']),
    );
  } else if (claims?.orgAdmin) {
    usersQuery = query(
      collection(db, 'users'),
      where('role', 'in', ['orgAdmin', 'orgUser', 'eyeStaff']),
      where('organization', '==', userData.organization),
    );
  } else {
    usersQuery = query(
      collection(db, 'users'),
      where('role', 'in', ['orgAdmin', 'orgUser']),
      where('organization', '==', userData.organization),
    );
  }

  if (state.unsubUsers) {
    state.unsubUsers();
  }
  state.unsubUsers = onSnapshot(usersQuery, (snapshot) => {
    const users = [...state.users];

    const changes = snapshot.docChanges();
    changes.forEach((c) => {
      if (c.type === 'added') {
        const organization = c.doc.data().organization.id;

        users.push({ ...c.doc.data(), id: c.doc.id, organization });
      } else if (c.type === 'modified') {
        const userIndex = users.findIndex((s) => s.id === c.doc.id);

        if (userIndex !== -1) {
          const organization = c.doc.data().organization.id;

          users[userIndex] = {
            ...c.doc.data(),
            id: c.doc.id,
            organization,
          };
        }
      } else if (c.type === 'removed') {
        const userIndex = users.findIndex((s) => s.id === c.doc.id);

        if (userIndex !== -1) {
          users.splice(userIndex, 1);
        }
      }
    });

    commit('SET_STATE', { key: 'users', value: users });
    commit('SET_STATE', { key: 'isLoading', value: false });

    if (!state.isInitialized) commit('INITIALIZE');
  });
};

export const resetState = ({ commit }) => {
  commit('RESET_STATE');
};
